function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M316.406,240.625c22.354-.265,43.962,3.657,64.063,6.641q-0.195,9.763-.391,19.531c-8.483,1.458-36.331-3.474-46.094-5.469-4.391-.9-11.617-3.248-17.187-1.953-9.616,2.236-15.755,10.432-25.781,11.328q-0.392-.585-0.782-1.172C295.312,257.263,306.715,248.516,316.406,240.625ZM477.734,241.8c16.367-.171,25.777,20.282,31.25,31.641l-1.172,1.171c-9.729-3.532-16.639-11.665-26.953-14.062l-51.171,5.469c-3.269.559-7.6,1.711-10.547,0.39-0.534-4.342-3.1-15.423,0-18.75Z"
});

var SvgMEyebrowshapeHardangledVector = function SvgMEyebrowshapeHardangledVector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "m_eyebrowshape_hardangled_vector",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMEyebrowshapeHardangledVector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/m_eyebrowshape_hardangled_vector.6f4f7de2.svg";
export { ForwardRef as ReactComponent };